import { createSelector } from "reselect";

const anmProfile = (state) => state.AnmSectionReducer.anmProfile;
export const getAnmProfile = createSelector([anmProfile], (data) => {
    return data; // Return the data
});

const listOfAshas = (state) => state.AnmSectionReducer.listOfAshas;
export const getListOfAshas = createSelector([listOfAshas], (data) => data)
const anmActivityIncentive = (state) => state.AnmSectionReducer.anmActivityIncentive;
export const getAnmActivityIncentive = createSelector([anmActivityIncentive], (data) => data)
const allRequests = (state) => state.AnmSectionReducer.allRequests
export const getapprovedPendingReq = createSelector([allRequests], (data) => data)
